export default __webpack_public_path__ + "static/media/profile-image.74a6a65b.png";